(function () {

  function syncLoopPrices(observer) {
    const aiodPriceEl = document.querySelector('.aiod-discounted-price');
    if (!aiodPriceEl) return false;

    const aiodPrice = aiodPriceEl.textContent.trim();
    if (!aiodPrice) return false;

    let synced = false;

    // =======================
    // 1️⃣ One-time purchase
    // =======================
    const oneTimeContainer = document.querySelector('.loop-widget-purchase-option-onetime');
    if (oneTimeContainer) {
      const priceEl = oneTimeContainer.querySelector('.loop-widget-purchase-option-price');
      const compareAtEl = oneTimeContainer.querySelector('.loop-widget-purchase-option-compare-at-price');

      if (priceEl && compareAtEl) {
        // Move current price → compare-at
        compareAtEl.textContent = priceEl.textContent.trim();
        compareAtEl.classList.remove('loop-display-none');

        // Set AIOD discounted price → displayed price
        priceEl.textContent = aiodPrice;

        synced = true;
      }
    }

    // =======================
    // 2️⃣ Subscribe / selling plan
    // =======================
    const sellingPlanContainer = document.querySelector('[data-loop-widget-selling-plan-group]');
    if (sellingPlanContainer) {
      const compareAtEl = sellingPlanContainer.querySelector('.loop-widget-purchase-option-compare-at-price');
      if (compareAtEl) {
        compareAtEl.textContent = aiodPrice;
        compareAtEl.classList.remove('loop-display-none');
        synced = true;
      }
    }

    // Disconnect observer after successful sync
    if (synced && observer) observer.disconnect();

    return synced;
  }

  function setupObserver() {
    const container = document.querySelector('.aiod-product-crossout-container') || document.body;

    const observer = new MutationObserver(() => {
      syncLoopPrices(observer);
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // Immediate try in case elements already exist
    syncLoopPrices(observer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }

})();